// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.floating-button {
  width: 50px;
  height: 50px;
  background-color: rgba(0, 123, 255, 0.7); /* 반투명한 파란색 */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: fixed;
  bottom: 20px;
  right: 20px;
  cursor: grab;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
  z-index: 4000;
  padding: 0%;
}

.floating-button:active {
  cursor: grabbing;
}

.floating-button:hover {
  background-color: rgba(0, 123, 255, 0.9);
}`, "",{"version":3,"sources":["webpack://./src/FloatingButton.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC,EAAE,aAAa;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,sCAAsC;EACtC,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".floating-button {\n  width: 50px;\n  height: 50px;\n  background-color: rgba(0, 123, 255, 0.7); /* 반투명한 파란색 */\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  cursor: grab;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n  z-index: 4000;\n  padding: 0%;\n}\n\n.floating-button:active {\n  cursor: grabbing;\n}\n\n.floating-button:hover {\n  background-color: rgba(0, 123, 255, 0.9);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
